// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ipoG","colBig":"styles_colBig__3yj7w","colSmall":"styles_colSmall__1S1Pr"};